import { render } from "./RankingPage.vue?vue&type=template&id=4423b0c0"
import script from "./RankingPage.vue?vue&type=script&lang=js"
export * from "./RankingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__